var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrendingIcon = function SvgTrendingIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 21,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#trending-icon_svg__a)",
    d: "M2.968 6.202c-.09 1.026-.154 2.843.418 3.616 0 0-.27-1.995 2.146-4.5.972-1.007 1.197-2.378.857-3.406-.192-.583-.545-1.064-.85-1.4-.18-.198-.042-.524.218-.512 1.571.075 4.119.537 5.201 3.414.475 1.263.51 2.568.284 3.895-.144.848-.654 2.732.51 2.964.83.165 1.232-.534 1.412-1.037.075-.21.335-.262.476-.095 1.402 1.69 1.522 3.681 1.232 5.395-.561 3.313-3.729 5.724-6.876 5.724-3.93 0-7.06-2.383-7.872-6.695-.326-1.74-.16-5.185 2.374-7.616.188-.183.496-.02.47.253"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#trending-icon_svg__b)",
    d: "M9.433 12.397c-1.449-1.975-.8-4.23-.445-5.128.048-.118-.08-.23-.18-.157-.623.45-1.9 1.506-2.495 2.994-.805 2.01-.747 2.995-.27 4.197.286.725-.047.878-.214.905-.163.027-.313-.087-.432-.207a2.76 2.76 0 0 1-.708-1.283c-.026-.105-.155-.134-.214-.048-.446.654-.677 1.702-.688 2.443-.035 2.291 1.752 4.149 3.913 4.149 2.725 0 4.71-3.191 3.144-5.859-.454-.777-.882-1.285-1.411-2.006"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "trending-icon_svg__a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-11.2525 -.05172 -.08023 19.555 7.218 20.312)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.314,
    stopColor: "#FFEBDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#FEA362"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.972,
    stopColor: "#F55F00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "trending-icon_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-.11892 12.4694 8.8601 .09478 7.85 8.453)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.214,
    stopColor: "#FFF3EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328,
    stopColor: "#FFF3EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    stopColor: "#FFF3EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672,
    stopColor: "#FFF3EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.793,
    stopColor: "#FFF3EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822,
    stopColor: "#FFF3EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.863,
    stopColor: "#FFF3EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFF3EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.941,
    stopColor: "#FFF3EB"
  })))));
};
export default SvgTrendingIcon;